export default class LayerResults {
  constructor(ct) {
    this.ct = ct;
    this.tabs = [];
  }

  init() {
    this.layerResults = jQuery("#template-layer-results").clone();
    this.layerResults.removeAttr("id");
    this.layerResults.attr("id", "main-grid");
    jQuery(".js-btn-close", this.layerResults).on("click", () => {
      this.layerResults.remove();
    });
    /*jQuery(".js-btn-export", this.layerResults).on("click", () => {
      this.ct.exportXls();
    });*/
    
    jQuery("body").append(this.layerResults);
  }

  addTab(removable, title, meta) {
    const tab = jQuery("#template-tab").clone();
    tab.attr("id", `tab-${LayerResults.TAB_ENUM++}`);
    jQuery(".js-tab-name", tab).html(title);
    console.log("---", meta);
    if (meta) {
      jQuery(".js-tab-tooltip", tab).html(meta);
      jQuery(".js-tab-tooltip").addClass("is-set");
    }
    if (removable) {
      jQuery(".js-tabs-extra", this.layerResults).append(tab);
    } else {
      jQuery(".js-tabs-default", this.layerResults).append(tab);
    }
    //jQuery(".js-tabs", this.layerResults).append(tab);

    tab.on("click", () => {
      this.setActiveTab(tab);
    });

    const tabContent = jQuery("#template-tab-content").clone();
    tabContent.attr("id", "content-" + tab.attr("id"));
    jQuery(".js-tabs-content", this.layerResults).append(tabContent);

    jQuery(".js-btn-close-tab", tab).on("click", () => {
      if (this.tabs.length > 0) {
        this.selectNearestTab(tab);
        // this.setActiveTab(this.tabs[this.tabs.length - 1].tab);
      }
      tab.remove();
      tabContent.remove();
      this.tabs = this.tabs.filter((t) => t.tab.attr("id") !== tab.attr("id"));
    });

    this.tabs.push({ tab, tabContent });

    this.setActiveTab(tab);
    return tabContent;
  }

  selectNearestTab(tab) {
    const index = this.tabs.findIndex((t) => t.tab.attr("id") === tab.attr("id"));
    if (index > 0) {
      if (index === this.tabs.length - 1) {
        this.setActiveTab(this.tabs[index - 1].tab);
      } else {
        this.setActiveTab(this.tabs[index + 1].tab);
      }
    } else if (index < this.tabs.length - 1) {
      this.setActiveTab(this.tabs[index + 1].tab);
    }
  }

  setActiveTab(tab) {
    jQuery(".js-tab", this.layerResults).removeClass("is-active");
    tab.addClass("is-active");
    jQuery(".js-tab-content", this.layerResults).removeClass("is-active");
    jQuery("#content-" + tab.attr("id")).addClass("is-active");
  }
}

LayerResults.TAB_ENUM = 0;
